<template>
<div class="dashboard cui-users__main-container" id="dDownload">
    <div class="page-title">
        <v-row>
            <v-col cols="12" md="6">
                <h6 class="font-weight-bold text-h5">Asset Command <span class="font-weight-medium"> - Dashboard</span>
                <v-icon color="rgb(0, 102, 124)" class="download-icon"  @click="exportPDF('dDownload', 'dashboardDownload')">mdi-download-box</v-icon>
                </h6>
            </v-col>
            <v-col md="2">
            </v-col>
            <v-col cols="12" md="2" class="bg-white">
                <v-select class="ambt-select"
                :items="homeLocations"
                label="Select Asset Owner"
                width="180px"
                :value="selectedDashboardHomeLocation"
                dense
                outlined
                float-right
                :menu-props="{ offsetY: true, contentClass:'ambt-select' }"
                @change="updateSelectedHomeLocation($event)"
                :disabled="getUserData ? !(getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') : false"
                ></v-select>
            </v-col>
            <v-col cols="12" md="2" class="bg-white">
                <v-select class="ambt-select"
                :items="assets"
                label="Select Asset Type"
                width="180px"
                :value="selectedAsset"
                dense
                outlined
                float-right
                :menu-props="{ offsetY: true, contentClass:'ambt-select' }"
                @change="updateSelectedAsset($event)"
                ></v-select>
            </v-col>
        </v-row>
    </div>
 <v-row>
    <v-col cols="12" md="6">
        {{palletStr}}
    </v-col>
 </v-row>
    <v-skeleton-loader
    :loading="loading"
          type="date-picker-days"
        >
        <v-row>
            <div class="location-cards my-2"  v-for="(location,i) in selected_data" :key="i">
            <v-card width="94%" class="pa-3" @click="getStatusByLocation(location.f[0]['v'])">
                <div class="my-2 text-center card-header">{{location.f[0]['v']}}</div>
                <v-row class="d-flex justify-space-between db-cards">
                    <v-col md="6">
                    <div class="text-center">
                        <h6 class="text-h6">Assets</h6>
                        <h1 class="text-h4 location-alert">{{location.f[1]['v']}}</h1>
                    </div>
                    </v-col>
                    <v-col md="6">
                    <div class="text-center">
                        <h6 class="text-h6">Alerts</h6>
                        <h1 class="text-h4 location-asset">{{location.f[2]['v']}}</h1>
                    </div>
                    </v-col>
                </v-row>
            </v-card>
            </div>
        </v-row>
    </v-skeleton-loader>
 <v-row>
   <v-col class="d-block mx-0 px-0 mt-5">
       <v-select
        :items="pages"
        width="80px"
        :value="items_per_page_dashboard"
        dense
        outlined
        class="float-left wd-80"
        :menu-props="{ offsetY: true, contentClass:'ambt-select' }"
        @change="updatePerPageItems($event)"
        ></v-select>
    <v-pagination flat
      v-model="destination_page"
      color = "rgb(0, 102, 124)"
      :length="locations.length > items_per_page_dashboard ?  Math.ceil(locations.length/items_per_page_dashboard) : 1"
      :total-visible="3" class="float-right"
    ></v-pagination>
    </v-col>
 </v-row>
</div>
</template>
<script>
import exportPdf from '@/components/mixins/exportPdf.js'
/* eslint-disable */
  export default {
      mixins: [exportPdf],
      data () {
      return {
        destination_page: 1,
        selected_data: [],
        pages: [10, 25, 50, 100],
        palletStr: "Pallet Types: A 30\"x30\", B - 54\"x40\", C - 82.5\"x54\"",
      }
    },
    computed: {
      locations () {
        this.selected_data = _.take(this.$store.getters.getLocationDeviseData, this.items_per_page_dashboard);
        this.destination_page = 1;
        return this.$store.getters.getLocationDeviseData
      },
      loading () {
          return this.$store.getters.getLoading
      },
      items_per_page_dashboard () {
          return this.$store.getters.getDashboardItemsPerPage
      },
      selectedAsset () {
          return this.$store.getters.getSelectedAsset
      },
      selectedDashboardHomeLocation () {
          return this.$store.getters.getSelectedDashboardHomeLocation
      },
      assets () {
          return this.$store.getters.getAssets
      },
      getUserData () {
        return this.$store.getters.getUserInfo
        },
        homeLocations() {
      return this.$store.getters.getHomeLocationList.sort();
    }
    },
    watch: {
      destination_page(val) {
        this.selected_data = _.slice(this.locations, (val * this.items_per_page_dashboard) - this.items_per_page_dashboard, (val * this.items_per_page_dashboard));
      },
      items_per_page_dashboard (val) {
        this.destination_page = 1;
      },
      selectedAsset (val) {
          this.$store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': val, "userOrgHomeLocation": this.selectedDashboardHomeLocation });
      },
      selectedDashboardHomeLocation (val) {
          this.$store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': this.selectedAsset, "userOrgHomeLocation": val });
      }
    },
     beforeMount(){
      this.$store.dispatch('getDeviceData', { widget: 'ASSET_COUNT', 'assetType': this.selectedAsset, "userOrgHomeLocation": this.selectedDashboardHomeLocation });
    },
    methods: {
        updatePerPageItems (val) {
            this.$store.dispatch('updateDashboardItemsPerPage', val);
        },
        updateSelectedAsset(val) {
           this.$store.dispatch('updateSelectedAsset', val)
        },
        updateSelectedHomeLocation(val) {
           this.$store.commit('SET_SELECTED_DASHBOARD_HOME_LOCATION', val)
        },
        getStatusByLocation (loc) {
            this.$store.dispatch('updateSelectedLocation', loc);
            this.$store.commit('SET_SELECTED_HOME_LOCATION', this.selectedDashboardHomeLocation)
            this.$store.commit("SET_SELECTED_ASSET_TYPE_STATUS", this.selectedAsset)
            this.$router.push({ name: 'Status' })
        },
        homeLocation () {
          let me = this;
         return setTimeout(function(){
                var userInfo = JSON.parse(localStorage.getItem('userData'))
                var listLoc =  _.flatten(userInfo.homeLocations.map(a => a.attributes)).map(a => a.value);
                listLoc.unshift('ALL')
                me.homeLocations = listLoc;
            }, 1000)
      }
    }
  }
</script>
<style>
.card-header{
    font-size:18px;
    height:40px;
    font-weight:500;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 22px;   
}
.db-cards h6{
    color: #00667c;
    font-weight:500;
}
.location-cards{
    display:flex;
    width:20%;
    justify-content: space-between;
}
.location-asset{
    color:#FF3700;
}
.ambt-select .theme--light.v-list{
    padding:0
}
.ambt-select .v-list-item{
    padding:0 10px;
}
.wd-80{
    width:80px;
}
.v-skeleton-loader__date-picker-days .v-skeleton-loader__avatar {
    height: 200px;
    width: 200px;
}
.v-skeleton-loader__avatar:nth-child(n+11) {
    display: none;
}
.bg-white fieldset{
    background:#fff;
}
@media(max-width:960px){
    .location-cards{
        width: 50%;
        justify-content: center;
    }
}
@media(max-width:570px){
    .location-cards{
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue